import React, { Component } from 'react'
import Header from '../../components/Headers/Header';
import { Container, Button, ListGroup, ListGroupItem, Form, FormGroup, Label, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { getTaskById, getTasks, assignTask, approveTask, rejectTask, removeTask, addToCms, updateTask, assignToMe } from 'services/taskService';
import { getZoomUsers, getZoomUser } from 'services/zoomUserService'
import { getCultures } from 'services/cultureService';
import { downloadFile } from 'services/downloadService';
import { getCategories } from 'services/categoryService';
import { saveAs } from 'file-saver';
import { getCountry } from 'services/roleService'
import GeneralModal from '../../components/Modals/GeneralModal';
import Select from 'react-select';
import { withAlert } from 'react-alert';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import GLightbox from 'glightbox'
import 'glightbox/dist/css/glightbox.css'
import { cdnPath } from "../../services/config"

class ProcessTask extends Component {

    constructor() {
        super();
        this.state = this.defaultState();

        this.token = window.zoomCrypt.get("token")
        this.networkId = window.zoomCrypt.get("networkId");
        this.sub = window.zoomCrypt.get("sub");
    }

    defaultState() {
        return {
            showTaskDetail: {},
            //openSubtaskModal: false,
            usersData: [],
            //tasksData: [],
            categoryData: [],
            //subtasksData: [],
            taskSubs: [],
            cultureData: [],
            subtaskDetail: {},
            openAssignModal: false,
            clickedTaskId: null,
            editorAssign: false,
            selectedAssignUser: null,
            elements: [],
            taskEditTitle: "",
            taskEditDescription: "",
            taskEditCountry: "",
            taskEditCity: "",
            taskEditIdea: "",
            taskEditPrice: 0,
            userId: null,
            downloadedFiles: [],
            showDownloadArea: false,
            countryData: [],
            selectedCountry: []
        };
    }

    refreshPage() {
      this.setState(this.defaultState, () => this.componentDidMount());
    }

    goTasksPage() {
        this.props.history.push('/admin/tasks')
    }

    async getCountry(){
        const response = await getCountry(this.token);
        let initCountry = [];
        response.countries.forEach((c) => {
            initCountry.push({
                label: c.Name,
                value: c.Id
            })
        })

        this.setState({
            countryData: initCountry,
        })
    }

    getCulture = async () =>{
        const response = await getCultures(this.token);
        if(response.success){
            let initialCultures = [];
            initialCultures = response.culture.map((culture) => {
                if(culture.IsActive){
                    return culture;
                }
            })

            this.setState({
                cultureData: initialCultures
            })
        }
    }

    taskDetail = async () => {
        const taskDetails = await getTaskById(this.token, this.networkId, this.props.match.params.id);
        const categoriesName = this.categoryNameConverter(taskDetails[0].data.categories ?? []);
        taskDetails[0].data.categoriesName = categoriesName.filter(item => item !== undefined).join(" ,");

        this.setState({
            showTaskDetail: taskDetails[0].data,
        });

        this.state.countryData.forEach((c) => {
            if (c.label === taskDetails[0].data.country) {
                this.setState({
                    selectedCountry: c
                })
            }
        })
    }

    async getUsers(){
      const response = await getZoomUsers(this.token, this.networkId);

      let initialUsers = [];
      if(response.users.length > 0){
        response.users.forEach((user) => {
            initialUsers.push({
                label: user.firstname + ' ' + user.lastname,
                value: user.Id,
                roleid: user.roleid,
            })
        })
    }
/* eslint-disable */
      this.setState({
          usersData: initialUsers
      })
  }
/*
    async getTasks(){
      const response = await getTasks(this.token, this.networkId);

      let initialTasks = [];
      let initialSubtasks = [];
      initialTasks = response.filter(task => task.data.type === "task");
      initialSubtasks = response.filter(task => task.data.type === "subtask");
      this.setState({
          tasksData: initialTasks,
          subtasksData: initialSubtasks,
      })
  }

  async taskSubs(){
      let initialSub = [];
        this.state.subtasksData.forEach((subtask) => {
            
            if(this.props.match.params.id == subtask.data.parentTaskId){
                initialSub.push({
                    subtask
                })
            }
        })

        this.setState({
          taskSubs: initialSub
        })
  }
*/
  cultureNameConverter(cultureId) {
    return this.state.cultureData.map((culture) => {
        if(cultureId === culture?.Id){
            return culture.Name
        }
    })
  }
/*
    subsArea(){
      return this.state.taskSubs.map((sub, index) => {
          return (
              <Button key={index} style={{ marginBottom: "10px" }} onClick={() => this.subtaskToggle(sub.subtask.id)}>{sub.subtask.data.title}</Button>
          )
      })
  }
*/
  assignToggle = (taskId, editor) => {
    if(editor){
        this.setState({
            openAssignModal: !this.state.openAssignModal,
            clickedTaskId: taskId,
            editorAssign: true,
        })
    }else {
        this.setState({
            openAssignModal: !this.state.openAssignModal,
            clickedTaskId: taskId,
            editorAssign: false,
        })
    }
}

    confirm = (taskId) => {
        confirmAlert({
            title: type === "remove",
            message: type === "Are you sure you want to delete ?",
            buttons: [
            {
                label: 'Yes',
                onClick: () => this.removeTask(taskId)
            },
            {
                label: 'No',
            }
            ]
        });
    };

    confirmApprove = (taskId) => {
        confirmAlert({
            title: "Approve Task",
            message: "Are you sure you want to approve ?",
            buttons: [
            {
                label: 'Yes',
                onClick: () => this.approveTask(taskId)
            },
            {
                label: 'No',
            }
            ]
        });
    };

    confirmReject = (taskId) => {
        confirmAlert({
            title: "Reject Task",
            message: "Are you sure you want to reject ?",
            buttons: [
            {
                label: 'Yes',
                onClick: () => this.rejectTask(taskId)
            },
            {
                label: 'No',
            }
            ]
        });
    };

    update = async e => {
        e && e.preventDefault();
        const alert = this.props.alert;
        const response = await updateTask(this.token,
                                          this.networkId,
                                          this.props.match.params.id,
                                          this.state.taskEditTitle,
                                          this.state.taskEditDescription,
                                          this.state.showTaskDetail.keywords,
                                          this.state.showTaskDetail.categories,
                                          this.state.taskEditIdea,
                                          this.state.taskEditCity,
                                          this.state.selectedCountry !== null ? this.state.selectedCountry.label : this.state.showTaskDetail.country,
                                          this.state.taskEditPrice);

        if(response.status === 200){
            this.taskDetail();
            alert.show("Task is updated")
        }
        else {
            alert.show('An error occured while updating the task')
        }
    }

    removeTask = async(taskId) => {
        const response = await removeTask(this.token, this.networkId, taskId);
        if(response.status === 200){
            this.goTasksPage();
        }
        else {
            const alert = this.props.alert;
            alert.show('An error occured while removing the task')
          }
    }

    async approveTaskService(taskId) {
        const alert = this.props.alert;
        const response = await approveTask(this.token, this.networkId, taskId);
        if(response.status === 200){            
            alert.show('Task is approved !');
            this.taskDetail();
        }
        else {
            alert.show('An error occured while approving the task')
          }
    }

    async assignToMe(taskId){
        const response = await assignToMe(this.token, this.networkId, taskId);
        if(response.status === 200){
            this.props.history.replace('/admin/process-task/' + taskId + '?task=localizer')
        }
        else {
            const alert = this.props.alert;
            alert.show('An error occured while assigning the task')
          }
    }

    assignConfirm = (id) => {
        confirmAlert({
            title: 'Assign Task',
            message: 'Are you sure you want to assign ?',
            buttons: [
            {
                label: 'Yes',
                onClick: () => this.assignToMe(id)
            },
            {
                label: 'No',
            }
            ]
        });
    };

    confirmCMS = (id) => {
        confirmAlert({
            title: 'Add To CMS',
            message: 'Are you sure you want to add to cms ?',
            buttons: [
            {
                label: 'Yes',
                onClick: () => this.addToCms(id)
            },
            {
                label: 'No',
            }
            ]
        });
    };


    addToCms = async (taskId) => {
        const response = await addToCms(this.token, this.networkId, taskId);
        if(response.status === 200){
            this.taskDetail();
            const alert = this.props.alert;
            alert.show("Added To CMS !");
        }
    }

    async rejectTaskService(taskId) {
        const alert = this.props.alert;
        const response = await rejectTask(this.token, this.networkId, taskId);
        if(response.status === 200){
            
            alert.show('Task is rejected !');
            this.taskDetail();
        }
        else{            
            alert.show('An error occured while rejecting the task')
          }
    }

    showAsset = (taskId) => {
        this.props.history.push(`/admin/published-edit/asset/${taskId}`)
    }

    approveTask = async (taskId) => {
        await this.approveTaskService(taskId);
    }

    rejectTask = async (taskId) => {
        await this.rejectTaskService(taskId);
    }

    async getUser(){
        const response = await getZoomUser(this.token, this.sub, this.networkId);
        if(response.success){
            this.setState({
                userId: response.user.Id
            })
        }
    }

  actionsArea(){
    return(
    this.state.showTaskDetail.status === 7 || this.state.showTaskDetail.status === 9 ?
    <Button onClick={() => this.confirmCMS(this.props.match.params.id)} color="success">Add to CMS</Button>
    : this.state.showTaskDetail.status === 11 ?
    <Button onClick={() => this.showAsset(this.state.showTaskDetail.assetId)} color="success">Show Asset</Button> :
    (this.state.showTaskDetail.status === 3 || this.state.showTaskDetail.status === 6) && this.state.showTaskDetail.createdBy === this.state.userId ?
       <span>
         <Button onClick={() => this.confirmApprove(this.props.match.params.id)} color="success">Approve</Button>
         <Button onClick={() => this.confirmReject(this.props.match.params.id)} color="danger">Reject</Button>
       </span>
      : this.state.showTaskDetail.status === 2 ?
      <Button onClick={() => this.confirm(this.props.match.params.id)} color="danger">Remove</Button>
      : ""
    )
  }

/*
  subtaskToggle = (subId) => {
    if(!this.state.openSubtaskModal){
          let subDetail = this.state.taskSubs.filter(sub => sub.subtask.id === subId);
          const { data } = subDetail[0].subtask;
          this.setState({
              subtaskDetail: {
                  title: data.title,
                  description: data.description,
                  city: data.city,
                  country: data.country,
                  ideaOriginator: data.ideaOriginator,
                  culture: this.cultureNameConverter(data.cultureId)
              }
          })
      }
      this.setState({openSubtaskModal: !this.state.openSubtaskModal})
  }
  */

    handleChangeAssignUser = selectedAssignUser => {
        this.setState({ selectedAssignUser });
    }

    handleChangeTaskTitle = e => {
      let taskTitle = e.target.value;
      this.setState({
        showTaskDetail: {
              title: taskTitle
          }
       });
  }

    handleChangeTaskDesc = e => {
        let taskDesc = e.target.value;
        this.setState({
          showTaskDetail: {
                description: taskDesc
            }
        });
    }

    handleChangeTaskCountry = e => {
        let taskCountry = e.target.value;
        this.setState({
          showTaskDetail: {
                country: taskCountry
            }
        });
    }

    handleChangeTaskCity = e => {
        let taskCity = e.target.value;
        this.setState({
          showTaskDetail: {
                city: taskCity
            }
        });
    }

    downloadMessage() {
        return(
            <div className="download-message-area">
                <img width="100" src="data:image/png;base64,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" alt="zoomin"></img><h4>Downladed Files ...</h4>
                {this.state.downloadedFiles.map((file) =>
                    <li key={file}>{ file } <img src="https://samherbert.net/svg-loaders/svg-loaders/oval.svg" width="14" alt="zoomin"></img></li>
                )}
            </div>
        )
    }

    downloadOneByOneAction = async (key,cultureId) => {
        const bucketFolderId = this.state.showTaskDetail.bucketFolderId;
        //const rawCultureId = this.state.showTaskDetail.rawCultureId;
        //const cultureId = this.state.showTaskDetail.cultureId;
        const questType = this.state.showTaskDetail.questType;
        const alert = this.props.alert;

        let files = [...this.state.downloadedFiles, key]
        this.setState({
            downloadedFiles: files,
            showDownloadArea: true
        })

        if(questType === "vj"){
            const response = await downloadFile(this.token, this.networkId, bucketFolderId, cultureId, key);
              fetch(response.presignedUrl, { method: 'GET' })
              .then(res => res.blob())
              .then(blob => {
                saveAs(blob, key)
                let index = this.state.downloadedFiles.map((item) => item).indexOf(key);
                files.splice(index, 1);

                this.setState({
                    downloadedFiles: files
                })

                if(this.state.downloadedFiles.length <= 0){
                    this.setState({
                        showDownloadArea: false
                     }) 
                }
              })
              .then(alert.show('Download is started. Please Wait !'))
        }else {
            const response = await downloadFile(this.token, this.networkId, bucketFolderId, cultureId, key);
              fetch(response.presignedUrl, { method: 'GET' })
              .then(res => res.blob())
              .then(blob => {
                saveAs(blob, key)
                let index = this.state.downloadedFiles.map((item) => item).indexOf(key);
                files.splice(index, 1);

                this.setState({
                    downloadedFiles: files
                })

                if(this.state.downloadedFiles.length <= 0){
                    this.setState({
                        showDownloadArea: false
                     })
                }
              })
              .then(alert.show('Download is started. Please Wait !'))
        }
    }

      downloadOneByOne() {
        let rawFiles = [];
        const questType = this.state.showTaskDetail.questType;
        let cultureId = this.state.showTaskDetail.cultureId;

        if(this.state.showTaskDetail.hasOwnProperty('assetFiles')){
            rawFiles.push(this.state.showTaskDetail.assetFiles?.cleanImage?.key,
                          this.state.showTaskDetail?.assetFiles?.videoHD?.key,
                          this.state.showTaskDetail.assetFiles?.cleanVideo?.key,
                          this.state.showTaskDetail.assetFiles?.image?.key,
                          this.state.showTaskDetail.assetFiles?.video?.key,
                          this.state.showTaskDetail.assetFiles?.premierProject?.key)

            if(this.state.showTaskDetail.assetFiles?.extraRawFiles?.length > 0){
                this.state.showTaskDetail.assetFiles?.extraRawFiles.forEach((e) => {
                    rawFiles.push(e.key)
                })
            }
        }
        else {            
            this.state.showTaskDetail?.rawAssetFiles.forEach((asset) => {
                rawFiles.push(asset)
            })
        }

        return(
          <Dropdown isOpen={this.state.btnDropright} toggle={() => { this.setState({ btnDropright: !this.state.btnDropright }); }}>
            <DropdownToggle caret>
              Download With Select &nbsp;
            </DropdownToggle>
            <DropdownMenu>
              { rawFiles.map((item, index) =>
                item !== undefined ?
                <DropdownItem key={index} onClick={() => this.downloadOneByOneAction(item, cultureId)}> { item.split('_').pop() } &nbsp; <i className="ni ni-cloud-download-95" /> </DropdownItem>
                : ""
              )}
            </DropdownMenu>
          </Dropdown>
        )
      }

    onAssignClick = async e => {
      e && e.preventDefault();
      const alert = this.props.alert;
      const response = await assignTask(this.token, this.networkId, this.state.clickedTaskId, this.state.selectedAssignUser.value);

      if(response.status === 200){
          this.refreshPage();
      }
      else {        
        alert.show('An error occured while assigning the task')
      }
  }

    async componentDidMount() {
      await this.getCountry();
      await this.getCulture();
      await this.getCategories();
      await this.taskDetail();
      //await this.getTasks();
      //await this.taskSubs();
      await this.getUsers();
      await this.getUser();

      this.setState({
        taskEditTitle: this.state.showTaskDetail?.title,
        taskEditCity: this.state.showTaskDetail?.city,
        taskEditCountry: this.state.showTaskDetail?.country,
        taskEditDescription: this.state.showTaskDetail?.description,
        taskEditIdea: this.state.showTaskDetail?.ideaOriginator,
        taskEditPrice: this.state.showTaskDetail?.price,
    })

      const elements = [];
        if(this.state.showTaskDetail?.questType === "vj" && this.state.showTaskDetail?.status >= 3){
            this.state.showTaskDetail?.rawAssetFiles.forEach((asset) => {
                let ext = asset.substr(asset.lastIndexOf('.') + 1).toLowerCase();
                ext = ext.replace(/\./g, "");
                const _cdnPath = `${cdnPath}/zoomin/${this.state.showTaskDetail.bucketFolderId}/37/${asset}`;

                if(ext === "png" || ext === "jpg") {
                    elements.push({
                        href: _cdnPath,
                        type: 'image',
                        title: asset,
                    })
                }else if(ext === "mp4" || ext === "mov"){
                    elements.push({
                        href: _cdnPath,
                        type: 'video',
                        title: asset,
                    })
                }
            })
        }

      if(this.state.showTaskDetail?.questType === "localizer" && this.state.showTaskDetail?.status === 8){
        const localizerCDNPath = `${cdnPath}/zoomin/${this.state.showTaskDetail.bucketFolderId}/8/`;
        const cleanImage = this.state.showTaskDetail.rawAssetFiles?.cleanImage.key;
        const cleanVideo = this.state.showTaskDetail.rawAssetFiles?.cleanVideo.key;
        const imageKey = this.state.showTaskDetail.rawAssetFiles?.image.key;
        const videoKey = this.state.showTaskDetail.rawAssetFiles?.video.key;

        elements.push({
            href: `${localizerCDNPath}${cleanImage}`,
            type: "image",
            title: `Clean Image: ${cleanImage}`,
          })

          elements.push({
            href: `${localizerCDNPath}${cleanVideo}`,
            type: "video",
            title: `Clean Video: ${cleanVideo}`,
          })

          elements.push({
            href: `${localizerCDNPath}${imageKey}`,
            type: "image",
            title: `Image: ${imageKey}`,
          })

          elements.push({
            href: `${localizerCDNPath}${videoKey}`,
            type: "video",
            title: `Video: ${videoKey}`,
          })
      }

      if(this.state.showTaskDetail?.questType === "localizer" && this.state.showTaskDetail?.status === 9){
        const localizerCDNPath = `${cdnPath}/zoomin/${this.state.showTaskDetail.bucketFolderId}/${this.state.showTaskDetail.cultureId}/`;
        const imageKey = this.state.showTaskDetail.assetFiles?.image.key;
        const videoKey = this.state.showTaskDetail.assetFiles?.video.key;

        if(this.state.showTaskDetail.hasOwnProperty('assetFiles')){
              elements.push({
                href: `${localizerCDNPath}${imageKey}`,
                type: "image",
                title: `Image: ${imageKey}`,
              })

              elements.push({
                href: `${localizerCDNPath}${videoKey}`,
                type: "video",
                title: `Video: ${videoKey}`,
              })
          }
      }

      if(this.state.showTaskDetail?.questType === "editor"){
        this.state.showTaskDetail?.rawAssetFiles.forEach((asset) => {
            const editorCDNPath = `${cdnPath}/zoomin/${this.state.showTaskDetail.bucketFolderId}/37/${asset}`;
            let ext = asset.substr(asset.indexOf('.')).toLowerCase();
            ext = ext.replace(/\./g, "");

            if(ext === "png" || ext === "jpg") {
                elements.push({
                    href: editorCDNPath,
                    type: 'image',
                    title: asset,
                })
            }else if(ext === "mp4" || ext === "mov"){
                elements.push({
                    href: editorCDNPath,
                    type: 'video',
                    title: asset,
                })
            }
        })

        if(this.state.showTaskDetail.hasOwnProperty('assetFiles')){
            const _cdnPath = `${cdnPath}/zoomin/${this.state.showTaskDetail.bucketFolderId}/8/`;
            const cleanImage = this.state.showTaskDetail.assetFiles?.cleanImage.key;
            const cleanVideo = this.state.showTaskDetail.assetFiles?.cleanVideo.key;
            const imageKey = this.state.showTaskDetail.assetFiles?.image.key;
            const videoKey = this.state.showTaskDetail.assetFiles?.video.key;

            elements.push({
                href: `${_cdnPath}${cleanImage}`,
                type: "image",
                title: `Clean Image: ${cleanImage}`,
              })

              elements.push({
                href: `${_cdnPath}${cleanVideo}`,
                type: "video",
                title: `Clean Video: ${cleanVideo}`,
              })

              elements.push({
                href: `${_cdnPath}${imageKey}`,
                type: "image",
                title: `Image: ${imageKey}`,
              })

              elements.push({
                href: `${_cdnPath}${videoKey}`,
                type: "video",
                title: `Video: ${videoKey}`,
              })
          }
      }

      this.setState({ elements })

        window.zoomGallery = GLightbox({
            touchNavigation: true,
            loop: true,
            autoplayVideos: false,
            elements: this.state.elements,
        });
    }

    onDownloadClick = async e => {
        e && e.preventDefault();
        const alert = this.props.alert;
        const bucketFolderId = this.state.showTaskDetail.bucketFolderId;
        let cultureId = this.state.showTaskDetail.cultureId;
        let aFiles = []
        let rFiles = this.state.showTaskDetail.rawAssetFiles;
        if(this.state.showTaskDetail.assetFiles){
            aFiles.push(this.state.showTaskDetail.assetFiles?.cleanVideo.key,
                        this.state.showTaskDetail.assetFiles?.videoHD.key,
                        this.state.showTaskDetail.assetFiles?.cleanImage.key,
                        this.state.showTaskDetail.assetFiles?.premierProject.key,
                        this.state.showTaskDetail.assetFiles?.image.key,
                        this.state.showTaskDetail.assetFiles?.video.key)

            if(this.state.showTaskDetail.assetFiles?.extraRawFiles?.length > 0){
                this.state.showTaskDetail.assetFiles?.extraRawFiles.forEach((e) => {
                    aFiles.push(e.key)
                })
            }

            rFiles = aFiles;
        }

        let files = [...this.state.downloadedFiles, ...rFiles]
        this.setState({
            downloadedFiles: files,
            showDownloadArea: true
        })

        rFiles.map(async (assetFile) => {
          const response = await downloadFile(this.token, this.networkId, bucketFolderId, cultureId, assetFile);
          fetch(response.presignedUrl, { method: 'GET' })
          .then(res => res.blob())
          .then(blob => {
            saveAs(blob, assetFile)
            let index = this.state.downloadedFiles.map((item) => item).indexOf(assetFile);
            files.splice(index, 1);

            this.setState({
                downloadedFiles: files
            })

            if(this.state.downloadedFiles.length <= 0){
                this.setState({
                    showDownloadArea: false
                 })
            }
          })
          .then(alert.show('Download is started. Please Wait !'))
        })
      }

      userNameConverter (userId) {
        let u = []
        this.state.usersData.map((user) => {
            if(userId === user?.value){
                u.push(user.label)
            }
        })
        return u[0]
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    }

    categoryNameConverter(categoryId) {
        if(categoryId !== undefined) {
            return this.state.categoryData.map((category) => {
                if (categoryId.includes(category?.category.Id)) {
                    return category.category.IsIab ? `${category.category.Name} ${category.category.ShortName}` : category.category.Name;
                }
            });
        }
      }

      getCategories = async () =>{
        const response = await getCategories(this.token);
        if(response.success){
            let initialCategories = [];
            response.category.forEach((category) => {
                if(category !== undefined){
                    initialCategories.push({ category })
                }
            })

            this.setState({
                categoryData: initialCategories
            })
        }
    }

    handleChangeCountry = selectedCountry => {
        this.setState({ selectedCountry })
    }

    render() {
        return (
            <div>
                <Header/>
                <Container className="mt-10">
                { this.state.showDownloadArea ? this.downloadMessage() : ""}
                { this.state.showTaskDetail?.questType === "localizer" ?
                      <FormGroup>
                        <h3 className="culture-title"><i className="ni ni-world" /> Culture: { this.cultureNameConverter(this.state.showTaskDetail?.cultureId) }</h3>
                      </FormGroup> : "" }
                    <h1>Task Detail</h1>
                    { this.state.showTaskDetail?.status !== 1 ?
                    <ListGroup>
                        <ListGroupItem><strong>Title:</strong> { this.state.showTaskDetail?.title }</ListGroupItem>
                        <ListGroupItem><strong>Created By:</strong> { this.userNameConverter(this.state.showTaskDetail?.createdBy) }</ListGroupItem>
                        { this.state.showTaskDetail?.assignedUserId !== null ? <ListGroupItem><strong>Assigned User:</strong> { this.userNameConverter(this.state.showTaskDetail?.assignedUserId) }</ListGroupItem> : "" }
                        <ListGroupItem><strong>Description:</strong> { this.state.showTaskDetail?.description }</ListGroupItem>
                        <ListGroupItem><strong>City:</strong> { this.state.showTaskDetail?.city }</ListGroupItem>
                        <ListGroupItem><strong>Country:</strong> { this.state.showTaskDetail?.country }</ListGroupItem>
                        <ListGroupItem><strong>Categories:</strong> { this.state.showTaskDetail.categoriesName }</ListGroupItem>
                        <ListGroupItem><strong>Keywords: </strong>{ this.state.showTaskDetail?.keywords?.join(', ') }</ListGroupItem>
                        <ListGroupItem><strong>Idea Originator:</strong> { this.state.showTaskDetail?.ideaOriginator }</ListGroupItem>
                        <ListGroupItem><strong>Task Type:</strong> { this.state.showTaskDetail?.questType }</ListGroupItem>
                        { this.state.showTaskDetail?.questType === "vj" ? <ListGroupItem><strong>Price:</strong> { this.state.showTaskDetail?.price }</ListGroupItem> : "" }
                    </ListGroup>
                    :
                    <div>
                        <Form>
                            <FormGroup>
                                <Label for="task">Task Title</Label>
                                <Input type="text" name="taskEditTitle" id="task_Edit_title" value={this.state.taskEditTitle} onChange={this.handleChange}/>
                            </FormGroup>

                            <FormGroup>
                                <Label for="task">Task Description</Label>
                                <Input type="text" name="taskEditDescription" id="task_Editdesc" value={this.state.taskEditDescription} onChange={this.handleChange}/>
                            </FormGroup>

                            <FormGroup>
                                <Label for="task">Task City</Label>
                                <Input type="text" name="taskEditCity" id="task_Edit_city" value={this.state.taskEditCity} onChange={this.handleChange}/>
                            </FormGroup>

                            <FormGroup>
                                <Label for="task">Task Country</Label>
                                <Select
                                    name="country"
                                    placeholder="Select Country"
                                    value={this.state.selectedCountry}
                                    options={ this.state.countryData }
                                    onChange={ this.handleChangeCountry }
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label for="task">Idea Originator</Label>
                                <Input type="text" name="taskEditIdea" id="task_Edit_idea" value={this.state.taskEditIdea} onChange={this.handleChange}/>
                            </FormGroup>

                            <FormGroup>
                                <Label for="task">Price</Label>
                                <Input type="number" name="taskEditPrice" id="task_Edit_price" value={this.state.taskEditPrice} onChange={this.handleChange}/>
                            </FormGroup>
                        </Form>

                        <Button onClick={this.update}>Update Task</Button>
                    </div> }
                    <hr></hr>
                  <h1>Actions</h1>
                  { this.state.showTaskDetail?.rawAssetFiles?.length > 0 || this.state.showTaskDetail.hasOwnProperty("assetFiles")
                  ? <Button color="success" onClick={() => window.zoomGallery.open()}>Show Gallery</Button>
                  : <h3>No asset file.</h3> }

                 { this.state.showTaskDetail?.questType === "localizer" && this.state.showTaskDetail?.assignedUserId === null
                ? <Button color="warning" onClick={() => this.assignConfirm(this.props.match.params.id)}>Assign To Me</Button> : "" }

                <GeneralModal
                        isOpen={this.state.openAssignModal}
                        toggle={this.assignToggle}
                        title='Assign Task'
                        primaryButton='Assign'
                        className='modal-content bg-light'
                        secondaryButton='Cancel'
                        onAction={this.onAssignClick}>

                        <Select
                            value={this.selectedAssignUser}
                            options={this.state.editorAssign ? this.state.usersData.filter(user => user.roleid === 4) : this.state.usersData}
                            onChange={this.handleChangeAssignUser}
                        ></Select>

                </GeneralModal>
                { this.state.showTaskDetail?.rawAssetFiles?.length > 0 || this.state.showTaskDetail?.assetFiles
                ? <>
                    <Button onClick={this.onDownloadClick} color="primary" data-clipboard-text="cloud-download-95" type="button"><div className="download-button"><i className="ni ni-cloud-download-95"></i><span>Download All Files</span></div></Button>
                    { this.downloadOneByOne() }
                </>
               : ""}
                {this.actionsArea()}
                </Container>
            </div>
        )
    }
}

export default withAlert()(ProcessTask)